import moment from "moment";
import { takeLatest, put, select, all } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { api } from "../staffSalesApi";

export const FETCH_DATA = "saga/staffSales/FETCH_DATA";
export const FETCH_DATA_SUCCESS = "saga/staffSales/FETCH_DATA_SUCCESS";
export const UPDATE_DATA = "saga/staffSales/UPDATE_DATA";
export const UPDATE_DATA_SUCCESS = "saga/staffSales/UPDATE_DATA_SUCCESS";
export const RESET_DATA = "saga/staffSales/RESET_DATA";
export const RESET_DATA_SUCCESS = "saga/staffSales/RESET_DATA_SUCCESS";

export const SET_LOADING = "saga/staffSales/SET_LOADING";
export const SET_UPDATES_LOADING = "saga/staffSales/SET_UPDATES_LOADING";

export const SET_DATES = "saga/staffSales/SET_DATES";
export const UPDATE_DATES = "saga/staffSales/UPDATE_DATES";
export const UPDATE_CUSTOM_RANGE = "saga/staffSales/UPDATE_CUSTOM_RANGE";

export const actionCreators = {
  fetchData: createAction(FETCH_DATA),
  updateData: createAction(UPDATE_DATA),
  resetData: createAction(RESET_DATA),
  updateDates: createAction(UPDATE_DATES),
  updateCustomRange: createAction(UPDATE_CUSTOM_RANGE)
};

export default function* watchStaffSales() {
  yield takeLatest(FETCH_DATA, fetchData);
  yield takeLatest(UPDATE_DATA, updateData);
  yield takeLatest(RESET_DATA, resetData);
}

function* fetchData() {
  yield put({ type: SET_LOADING, payload: true });
  yield setDates();

  try {
    yield all(getAllData(FETCH_DATA_SUCCESS));

    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* fetchDataPoints(actionType) {
  const params = yield getCommonApiParams();

  try {
    const {
      data: { dataPoints }
    } = yield api.getDataPoints({ params });

    yield put({ type: actionType, payload: { dataPoints } });
  } catch (err) {
    console.error(err);
  }
}

function* fetchPies(actionType) {
  const params = yield getCommonApiParams();
  try {
    const { data } = yield api.getPieCharts({ params });
    yield put({ type: actionType, payload: { pieCharts: data } });
  } catch (err) {
    console.error(err);
  }
}

function* fetchTable(actionType) {
  const params = yield getCommonApiParams();

  try {
    const {
      data: { tableInfo }
    } = yield api.getTable({ params });

    yield put({ type: actionType, payload: { tableData: tableInfo } });
  } catch (err) {
    console.error(err);
  }
}

function* updateData() {
  yield put({ type: SET_UPDATES_LOADING, payload: true });

  try {
    yield all(getAllData(UPDATE_DATA_SUCCESS));
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (err) {
    console.error(err);
  }
}

function* resetData() {
  yield put({ type: SET_UPDATES_LOADING, payload: true });
  yield setDates();

  yield put({ type: RESET_DATA_SUCCESS });
  yield put({ type: SET_UPDATES_LOADING, payload: false });
}

function* setDates() {
  const { calendarEndDate: endDate, calendarStartDate } = yield select(
    (state) => state.commonReducer.currentUser
  );

  const startDate = moment(endDate).startOf("month").format("YYYY-MM-DD");

  yield put({
    type: SET_DATES,
    payload: {
      startDate,
      endDate,
      calendarStartDate
    }
  });
}

function* getCommonApiParams() {
  return yield select((state) => {
    const {
      currentUser: { organizationId, locationId, objectId, regionId }
    } = state.commonReducer;

    const {
      selectedRequestDates: { startDate, endDate }
    } = state.staffSales;

    if (!organizationId && !locationId && !objectId && !regionId && !startDate && !endDate) return;

    return {
      organization_id: organizationId,
      location_id: locationId,
      object_id: objectId,
      region_id: regionId,
      start_date: startDate,
      end_date: endDate
    };
  });
}

function getAllData(actionType) {
  return [fetchDataPoints(actionType), fetchTable(actionType), fetchPies(actionType)];
}
